import axios from "axios";
import React, { createContext, useEffect } from "react";

export const CaptchContext = createContext({
  gre: () => {},
});

function CaptchProvider({ children }) {
  const handleLoaded = (_) => {
    window.grecaptcha.ready((_) => {
      window.grecaptcha
        .execute("6LfUyy8rAAAAAGswVj7llAhCDsMo_jQFhr_m8nNs", {
          action: "homepage",
        })
        .then((token) => {
          // ...
        });
    });
  };
  useEffect(() => {
    // Add reCaptcha
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6LfUyy8rAAAAAGswVj7llAhCDsMo_jQFhr_m8nNs";
    script.addEventListener("load", handleLoaded);
    document.body.appendChild(script);
  }, []);
  const gre = (fnSuccess) => {
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute("6LfUyy8rAAAAAGswVj7llAhCDsMo_jQFhr_m8nNs", {
          action: "submit",
        })
        .then(function (token) {
          console.log(token);
          axios
            .post(
              `${process.env.REACT_APP_API_URL}/verify`,
              // Global_var.BASE_URL + Global_var.CAPTCHA_VERIFY_URL,
              {
                response: token,
                headers: {
                  "Cache-Control": "no-cache",
                  "Content-Type": "application/x-www-form-urlencoded",
                  "Access-Control-Allow-Origin": "*",
                },
              }
            )
            .then((res) => {
              console.log(res);
              if (res.data.success) {
                fnSuccess();
              } else {
                alert("Failed to varify captcha please reload the page");
                // window.location.reload();
                return;
              }
            });
        });
    });
  };
  return (
    <CaptchContext.Provider value={{ gre }}>{children}</CaptchContext.Provider>
  );
}

export default CaptchProvider;
